<template>
	<div class="emailTemplatePreview">
		<div class="search-input">
			<b-form-input
				class="input-search"
				:placeholder="$t('userDashboard.messages.search')"
				@update="searchEmailTemplate"
			></b-form-input>
			<MagnifyIcon class="icon-search" />
		</div>
		<div
			class="content-body-div"
			:class="{ 'no-data': !listingEmailTemplate.length }"
		>
			<b-row no-gutters>
				<div
					v-for="(item, index) in listingEmailTemplate"
					:key="index"
					@click="showPopup(item)"
					v-b-tooltip
					:title="item.description"
				>
					<div class="template-item">
						<div class="title">{{ item.subject }}</div>
					</div>
				</div>
			</b-row>
			<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
				<span slot="no-results">
					<b-alert show variant="light">{{
						$t('adminDashboard.list.dataEmpty')
					}}</b-alert>
				</span>
				<span slot="no-more"></span>
			</infinite-loading>
		</div>
		<b-modal
			id="popup"
			modal-class="modal-email-template"
			size="xl"
			centered
			hide-header
			hide-footer
		>
			<!-- <div class="emailtemplate-render" v-html="emailTemplate.content" v-if="emailTemplate"></div> -->
			<b-img
				:src="emailTemplate.image_template"
				v-if="emailTemplate"
				fluid="true"
				:alt="$t('buySell')"
			></b-img>
		</b-modal>
	</div>
</template>

<script>
// Icons
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import InfiniteLoading from 'vue-infinite-loading';

import { mapActions, mapGetters } from 'vuex';

export default {
	components: {
		MagnifyIcon,
		InfiniteLoading
	},
	data() {
		return {
			config: {
				limit: 10,
				take: 10,
				page: 1,
				search: ''
			},
			emailTemplate: null
		};
	},
	computed: {
		...mapGetters('EmailTemplateController', ['listingEmailTemplate'])
	},
	methods: {
		...mapActions('EmailTemplateController', ['GET_EMAIL_TEMPLATE']),
		async infiniteHandler($state) {
			let response = await this.GET_EMAIL_TEMPLATE({
				search: this.config.search || null,
				take: this.config.take,
				page: this.config.page
			});
			if (response) {
				if (!response.data.data) {
					return $state.complete();
				}
				if (response.data.data.length > 0) {
					this.config.take = await this.config.limit;
					this.config.page += await 1;
					await $state.loaded();
				} else await $state.complete();
			}
		},
		searchEmailTemplate(value) {
			setTimeout(async () => {
				this.config.search = value;
				this.$store.commit(
					'EmailTemplateController/RESET_LISTING_EMAIL_TEMPLATE'
				);
				this.config.take = this.config.limit;
				this.config.page = 1;
				this.$nextTick(() => {
					this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
				});
			}, 500);
		},
		showPopup(item) {
			this.emailTemplate = item;
			this.$bvModal.show('popup');
		}
	}
};
</script>
<style lang="scss">
@import 'adminEmailTemplatePreview.scss';
</style>
